module.exports = __webpack_public_path__ + "static/media/10(4).47b97123.jpg";